import { render, staticRenderFns } from "./riskWarning.vue?vue&type=template&id=489b36f3&scoped=true"
import script from "./riskWarning.vue?vue&type=script&lang=js"
export * from "./riskWarning.vue?vue&type=script&lang=js"
import style0 from "./riskWarning.vue?vue&type=style&index=0&id=489b36f3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489b36f3",
  null
  
)

export default component.exports